import { action, makeObservable, observable } from 'mobx';
import { AuthStore } from './authStore';
import { CatalogStore } from './catalogStore';
import { CartStore } from './cartStore';
import { OrderStore } from './orderStore';
import { ProfileStore } from './profileStore';
import { PaymentStore } from './paymentStore';
import { BusinessStore } from './businessStore';
import { MembershipStore } from './membershipStore';
import { InvitationStore } from './invitationStore';
import { NotificationInboxStore } from './notificationInboxStore';

export type NotificationVariant = 'success' | 'error' | 'info' | 'warning';

export type Notification = {
  message: string;
  variant: NotificationVariant;
  id: number;
};

export class BuyerRootStore {
  authStore: AuthStore;
  catalogStore: CatalogStore;
  cartStore: CartStore;
  orderStore: OrderStore;
  paymentStore: PaymentStore;
  profileStore: ProfileStore;
  businessStore: BusinessStore;
  membershipStore: MembershipStore;
  invitationStore: InvitationStore;
  notificationInboxStore: NotificationInboxStore;
  notification: Notification | null = null;
  private nextNotificationId = 1;

  constructor() {
    this.authStore = new AuthStore();
    this.catalogStore = new CatalogStore();
    this.cartStore = new CartStore();
    this.orderStore = new OrderStore();
    this.paymentStore = new PaymentStore();
    this.profileStore = new ProfileStore();
    this.businessStore = new BusinessStore();
    this.membershipStore = new MembershipStore();
    this.invitationStore = new InvitationStore();
    this.notificationInboxStore = new NotificationInboxStore();
    this.authStore.attachCartStore(this.cartStore);
    this.cartStore.setIdentityProvider(() => this.authStore.buyerIdentity);
    this.authStore.attachOrderStore(this.orderStore);
    this.authStore.attachIdentityStores({
      business: this.businessStore,
      membership: this.membershipStore,
      invitation: this.invitationStore,
    });
    makeObservable(this, {
      notification: observable,
      notify: action.bound,
      dismissNotification: action.bound,
    });
  }

  notify(message: string, variant: NotificationVariant = 'info'): void {
    this.notification = { message, variant, id: this.nextNotificationId++ };
  }

  dismissNotification(): void {
    this.notification = null;
  }
}
